import ericPic from "@/public/images/artists/eric.png";
import { Artist } from "@/types/types";

export const eric = {
  id: "261",
  name: "Eric",
  image: ericPic,
  description: `Eric's voice is bright and slightly pinched, with a tight, forward tone that gives it a distinctive pop-punk urgency. His tone is clean rather than raspy and can cut clearly through fast, energetic arrangements.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Feric-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Belting", "Rock"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 68,
      },
      sweetSpot: 58,
    },
  },
} as const satisfies Artist;
